import { InfoRow } from '../../components/InfoRow';
import { Label } from '../../components/Label';
import React from 'react';

import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { formatNumberWithSpaces } from 'shared/common/utils/formatNumberWithSpaces';
import { transformNumToString } from '../../../common/utils';

import { useSelector } from 'react-redux';

import { ETestIds } from '../../constants/testIds';
import { PERCENT, NBSP, RUB } from '../../../common/constants';
import { selectCalculatorValues } from '../../selectors/selectCalculatorValues';

export const PskGroupContainer: React.FC = () => {
  const deviceType = useDeviceType();
  const {
    mortgagePercentRate,
    discountMortgagePercent,
    calculatedValues: {
      monthlyPaymentMinRate,
      monthlyPaymentMaxRate,
      creditSum,
      rateWithoutDiscount,
      discountMonthlyPayment,
    },
  } = useSelector(selectCalculatorValues);

  return (
    <div className={cn(styles['psk'], styles[deviceType])}>
      <InfoRow
        title={'Ставка'}
        description={transformNumToString(mortgagePercentRate) + PERCENT}
        label={<Label background={'red'}>{`-${transformNumToString(discountMortgagePercent)}${PERCENT}`}</Label>}
        crossedContent={rateWithoutDiscount + PERCENT}
      />
      <InfoRow
        title={'Сумма кредита'}
        description={formatNumberWithSpaces(creditSum) + NBSP + RUB}
        testId={ETestIds.CreditSum}
      />
      <InfoRow
        title={'Ежемесячный платёж'}
        description={formatNumberWithSpaces(monthlyPaymentMinRate) + NBSP + RUB}
        label={
          <Label
            background={'var(--theme-green)'}
          >{`Экономия ${formatNumberWithSpaces(discountMonthlyPayment)} ${RUB}/мес`}</Label>
        }
        crossedContent={formatNumberWithSpaces(monthlyPaymentMaxRate) + NBSP + RUB}
        testId={ETestIds.MonthlyPayment}
      />
    </div>
  );
};
